import {FC, Suspense} from 'react'
import {RenderIf} from 'components/Basic'
import {useLocation} from 'react-router'
import {PoliciesFooter} from './PoliciesFooter'
import {SettingsFooter} from './SettingsFooter'
import {EndpointsFooter} from './EndpointsFooter'
import {useActions} from 'hooks'

export const PageFooter: FC = () => {
  const {pathname} = useLocation()
  const {isUserLoggedIn} = useActions()

  if (!isUserLoggedIn) {
    return null
  }

  return (
    // Suspense is used to handle the lazy loading of translations for the footer
    <Suspense fallback={<div />}>
      <RenderIf
        isTrue={
          pathname?.includes('/policies') &&
          !pathname?.includes('/policies/bypass')
        }
      >
        <PoliciesFooter />
      </RenderIf>
      <RenderIf isTrue={pathname?.includes('/settings')}>
        <SettingsFooter />
      </RenderIf>
      {/* This footer should not collide with settings endpoint route */}
      <RenderIf isTrue={pathname === '/endpoints'}>
        <EndpointsFooter />
      </RenderIf>
    </Suspense>
  )
}
